import { keyframes } from '@mui/material'
import type { Keyframes } from '@emotion/react'

export const pulse: Keyframes = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`
